import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';

export const submitCoApplicantHandlers = [
    http.put('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/co-applicant', async () => {
        const session = MockServiceWorker.getMockedSession();
        MockServiceWorker.setMockedSession({
            ...session,
            state: 'TRANSITION',
        });

        return HttpResponse.json([]);
    }),
];
